import Action, { ActionType } from '../Actions/ActionTypes'
import { Reducer } from 'redux'
import FileState from '../State/BookmarkState'

const actionBookmarkShow = (oldState: FileState, _action: Action): FileState => {
    return { ...oldState, show : !oldState.show}
}

type Process = (oldState: FileState, action: Action) => FileState

export const BookmarkReducer: Reducer<FileState, Action> = (state: FileState = { show: false}, action: Action): FileState => {

    let actionMap = new Map<ActionType, Process>()
    actionMap.set(ActionType.BOOKMARK_SHOW, actionBookmarkShow)

    return actionMap.get(action.type)?.call(undefined, state, action) ?? state

}


